var API_DOMAIN = "https://ashwinmadhantraders.zentexus.in/api";

export default API_DOMAIN;
